<template>
  <div class="" ref="datepicker">

    <div class="datepicker-container" v-if="step==1">
      <div class="datepickerHeader">
        <p class="datepickerHeaderText">{{ monthNames[currentMonth] }} {{ currentYear }}</p>
        <div class="monthArrows">
          <p @click="changeMonth(-1)" :class="{ 'disabled': isCurrentMonth }">&lt;</p>
          <p @click="changeMonth(1)">&gt;</p>
        </div>
      </div>
      <div class="calendarBlock">
        <div class="day-names">
          <span v-for="day in dayNames" :key="day" class="day-name">{{ day }}</span>
        </div>
        <div class="days">
          <span
            v-for="day in daysInMonth" 
            :key="day.date ? day.date.toISOString() : 'empty-' + Math.random()"
            :class="{
              'current-day': isToday(day.date),
              'selected-day': isSelected(day.date),
              'next-month-day': isNextMonth(day.date),
              'disabled': isDisabled(day.date) // Добавляем класс disabled
            }"
            class="day"
            @click="selectDate(day.date)"
          >
            {{ day.date ? day.date.getDate() : '' }}
          </span>
        </div>
      </div>
      <button class="nextButton" @click="nextStep">Далее</button>
    </div>
    <div class="datepicker-container" v-else>
      <div class="datepickerHeader" style="">
        <p class="datepickerHeaderText time" @click="step=1">{{ selectedDate.toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
          }).replace(/г\./, '') }}</p>
      </div>
      <div class="timeBlock">
        <div class="time-grid">
          <div 
          v-for="(hour, index) in hours" 
          :key="index" 
          class="time-cell" 
          :class="{ 'selected': isSelectedHour(hour) }"
          @click="selectHour(hour)"
          >
            {{ hour }}:00
          </div>
        </div>
      </div>
      <VueSlider ref="slider" v-model="countHours" @dragging="aboveZeroSlider" @drag-end="newSelectedEndDate" marks :min=0 :max=12 :adsorb=true tooltip="hover" silent :clickable=false :drag-on-click=false />
      <div class="marksBlock">
        <p>1 час</p>
        <p>12 часов</p>
      </div>
      <div class="nextButton" @click="hideDatePicker">
        Готово
      </div>
    </div>
  </div>
</template>
<script>
import VueSlider from "vue-3-slider-component";
export default {
  name: "DatePicker",
  data() {
    return {
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth(),
      currentHour: new Date().getHours(),
      currentDate: new Date(),
      hours: [],
      monthNames: [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ],
      dayNames: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
      selectedDate: null,
      selectedEndDate: null,
      step: 1,
      countHours: 1,
      isTodayTime: true
    }
  },
  setup() {
    
  },
  props: {
    girlId: {
      type: String
    },
    oneHourPrice: {
      type: Number
    },
    nightPrice: {
      type: Number
    }
  },
  computed: {
    daysInMonth() {
      const days = [];
      const firstDay = new Date(this.currentYear, this.currentMonth, 1);
      const lastDay = new Date(this.currentYear, this.currentMonth + 1, 0);

      // Добавление пустых ячеек для первых дней месяца
      for (let i = 0; i < (firstDay.getDay() || 7) - 1; i++) {
        days.push({ date: null, isToday: false });
      }

      for (let day = 1; day <= lastDay.getDate(); day++) {
        const date = new Date(this.currentYear, this.currentMonth, day);
        days.push({
          date,
          isToday: date.toDateString() === new Date().toDateString()
        });
      }
      const remainingDays = 42 - days.length; // Осталось для заполнения до 42 ячеек
    for (let i = 1; i <= remainingDays; i++) {
      const date = new Date(this.currentYear, this.currentMonth + 1, i);
      days.push({ date, isToday: false });
    }

    return days;
    },
    isCurrentMonth() {
      const today = new Date();
      return today.getMonth() === this.currentMonth && today.getFullYear() === this.currentYear;
    }
  },
  methods: {
    changeMonth(direction) {
      if (direction === -1 && this.isCurrentMonth) return;
      this.currentMonth += direction;
      if (this.currentMonth > 11) {
        this.currentMonth = 0;
        this.currentYear++;
      } else if (this.currentMonth < 0) {
        this.currentMonth = 11;
        this.currentYear--;
      }
    },
    twelveHours() {
      for (let i = 0; i < 12; i++) {
        this.hours.push((this.currentHour+1 + i) % 24);
      }
    },
    hideDatePicker() {
      this.$emit('hideDatePicker')
    },
    selectDate(date) {
      if (date) {
        this.selectedDate = date;
        if (this.currentHour != 23) this.selectedDate.setHours(this.currentHour + 1, 0, 0, 0)
        else this.selectedDate.setHours(this.currentHour, 0, 0, 0)
        this.$emit('newDate', this.selectedDate);
      }
    },
    isSelected(date) {
      return date && this.selectedDate && date.toDateString() === this.selectedDate.toDateString();
    },
    isToday(date) {
      return date && !this.selectedDate && date.toDateString() === new Date().toDateString();
    },
    isDisabled(date) {
      return date && date < this.currentDate.setHours(0, 0, 0, 0) && date.getMonth() === this.currentMonth;
    },
    isNextMonth(date) {
      return date && date.getMonth() !== this.currentMonth;
    },
    selectHour(hour) {
      const baseDate = new Date(this.selectedDate); // Копия выбранной даты
      // const currentHour = baseDate.getHours(); // Текущий выбранный час
      const firstHalf = this.hours.slice(0, this.hours.indexOf(0)); // Первая половина до индекса
      const secondHalf = this.hours.slice(this.hours.indexOf(0)); 
      if (firstHalf.includes(hour)) {
        if (!firstHalf.includes(this.selectedDate.getHours())) baseDate.setDate(baseDate.getDate() - 1)
      }
      if (secondHalf.includes(hour)) {
          if (!secondHalf.includes(this.selectedDate.getHours())) baseDate.setDate(baseDate.getDate() + 1)
      }
      baseDate.setHours(hour, 0, 0, 0)     
      
      this.selectedDate = baseDate;
      
      this.selectedEndDate = new Date(this.selectedDate)
      this.selectedEndDate.setHours(this.selectedEndDate.getHours() + this.$refs.slider.modelValue) 
      
      this.$emit("newEndDate", this.selectedEndDate);
      this.$emit("newDate", this.selectedDate);
    },
    isSelectedHour(hour) {
      // Проверяем, был ли выбран данный час
      if (!this.selectedDate) return false;
      return this.selectedDate.getHours() === hour;
    },
    nextStep() {
      this.selectedDate = new Date(this.selectedDate.setHours(this.currentHour+1, 0, 0, 0));
      this.isTodayTime = this.selectedDate
      let baseDate = new Date(this.selectedDate)
      this.selectedEndDate = baseDate
      this.selectedEndDate.setHours(baseDate.getHours() + 1)
      this.$emit('newEndDate',this.selectedEndDate)
      this.step += 1
    },
    aboveZeroSlider() {
      if (this.$refs.slider.modelValue <= 0) this.$refs.slider.setValue(1)
    },
    newSelectedEndDate() {
      console.log(this.selectedDate)
      let baseDate = new Date(this.selectedDate)
      if (this.$refs.slider.modelValue == 0 || this.countHours == 0) {
        this.$refs.slider.setValue = 1
        this.countHours = 1
      }
      console.log(baseDate)
      this.selectedEndDate = baseDate
      this.selectedEndDate.setHours(baseDate.getHours() + this.$refs.slider.modelValue)
      this.$emit('newEndDate',this.selectedEndDate)
    },
    handleClickOutside(event) {
      const componentElement = this.$refs.datepicker;
      if (!componentElement.contains(event.target) && !event.target.closest('.calendarPicker')) {
        if (!event.target.classList.contains('day') && !event.target.classList.contains('nextButton') && !event.target.classList.contains('time')) this.$emit('hideDatePicker')
        console.log(event.target.className)
      }
    }
  },
  mounted() {
    this.selectedDate = new Date()
    this.selectedDate.setHours(this.currentHour+1, 0, 0, 0)
    this.$emit('newDate', this.selectedDate);
    this.twelveHours()
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  components: {
    VueSlider
  }
};
</script>

<style scoped>
.datepicker-container {
  position: absolute;
  background-color: #FBFBFB;
  border: 1px solid #f4f4f4;
  border-radius: 16px;
  padding:5%;
  width: 80%;
  bottom:110%;
  right: 0;
  z-index: 10;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  display: flex;
  flex-direction: column;
  gap:15px;
  color: #333333;
}
.datepickerHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.datepickerHeaderText {
  font-size: 24px;
  font-weight: 600;
}
.datepickerHeaderText.time {
  cursor: pointer;
  transition: 0.3s;
  position: relative;
}
.datepickerHeaderText.time::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: #FF8989;
  transition: width 0.3s ease-in-out;
}

.datepickerHeaderText.time:hover::after {
  width: 100%;
}
.monthArrows {
  display: flex;
  justify-content: center;
  align-items: center;
  gap:20px;
}
.monthArrows p {
  cursor: pointer;
  user-select: none;
}
.monthArrows p.disabled {
  color: #ccc; /* Серый цвет для неактивной стрелки */
  cursor: default; /* Изменяем курсор на "недоступен" */
}
.calendarBlock {
  display: grid;
  grid-template-rows: auto 1fr;
}

.day-names {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  font-weight: bold;
  margin-bottom: 5px;
  text-align: center;
}

.days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(6, 1fr); /* Гарантирует, что всегда будет 6 строк */
}

.day {
  border: 1px solid #D5D4DF;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  aspect-ratio: 1 / 1;
  text-align: center;
  width: 100%;
  height: 100%;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
}

.current-day, .selected-day {
  background-color: #FF8989 !important;
  font-weight: bold;
  color: white !important;
}
.next-month-day {
  background-color: #F6FAFD;
  color: #5B5B5B;
}
.nextButton {
  background-color: #FF8989;
  color: white;
  width: 100%;
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 2%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  user-select: none;
}
.timeBlock {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: white;
  padding:3%;
  border-radius: 10px;
}

.time-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 столбца */
  grid-template-rows: repeat(4, 1fr);    /* 4 строки */
  gap: 10px;
  width: 100%;
  max-width: 400px;
}

.time-cell {
  background-color: #F6FAFD;
  padding: 5px;
  text-align: center;
  font-size: 18px;
  border-radius: 8px;
  color: #000000;
  cursor: pointer;
  user-select: none;
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
}
.time-cell.selected {
  background-color: #FF8989; /* Цвет выбранной ячейки */
  color:white;
  font-weight: 600;
}
.marksBlock {
  display: flex;
  justify-content: space-between;
  color: #000000;
  font-size: 14px;
}
:deep(.vue-slider-process) {
  background-color: #FF8989;
}
:deep(.vue-slider-dot-handle) {
  background-color: #FF8989;
}
:deep(.vue-slider-dot-handle-focus) {
  box-shadow: 0 0 1px 2px #ff8989b2;
}
:deep(.vue-slider-rail) {
  background-color: #E6E6E6;
}
:deep(.vue-slider-mark-step) {
  background-color: #E6E6E6;
  scale:3;
}
:deep(.vue-slider-mark-step-active) {
  background-color: #FF8989;
}
:deep(.vue-slider-mark:first-child .vue-slider-mark-step) {
  display: block;
}
:deep(.vue-slider-mark:last-child .vue-slider-mark-step) {
  display: block;
}
:deep(.vue-slider-mark-label) {
  display: none;
}
:deep(.vue-slider-dot-tooltip-inner) {
  background-color: #FF8989;
  font-weight: 600;
}
:deep(.vue-slider-dot-tooltip-inner) {
  border-color: #FF8989;
}
:deep(.vue-slider) {
  width: 95% !important;
  margin: 0 auto;
}
.day.disabled {
  cursor: not-allowed;
  pointer-events: none;
  background-color: #e1e1e149;
}
</style>
